export const ACCOUNT_LOGIN = "ACCOUNT_LOGIN";
export const VERIFY_TOKEN = "VERIFY_TOKEN";
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";
export const GET_ALL_CAGURA_USER = "GET_ALL_CAGURA_USER";
export const ADMIN_USER_DELETE_ITEM = "ADMIN_USER_DELETE_ITEM";
export const ADMIN_USER_GET_USERS = "ADMIN_USER_GET_USERS";
export const ADMIN_USER_ADD_NEW = "ADMIN_USER_ADD_NEW";
export const ADMIN_USER_UPDATE = "ADMIN_USER_UPDATE";
export const SAVE_PERMISSION_ITEM = "SAVE_PERMISSION_ITEM";
export const ADMIN_GET_PERMSSION_LIST = "ADMIN_GET_PERMSSION_LIST";
export const ADMIN_CHANGE_PERMSSION = "ADMIN_CHANGE_PERMSSION";
export const USER_CUSTOMER_GET_ALL = "USER_CUSTOMER_GET_ALL";
export const ADMIN_USER_GET_ACCOUNT_OVERVIEW = "ADMIN_USER_GET_ACCOUNT_OVERVIEW";
export const ADMIN_USER_FUNDS_OVERVIEW = "ADMIN_USER_FUNDS_OVERVIEW";
export const ADMIN_USER_GET_SUBSCRIPTION_REPORT = "ADMIN_USER_GET_SUBSCRIPTION_REPORT";
export const ADMIN_USER_STREAMING_REPORT = "ADMIN_USER_STREAMING_REPORT";
export const ADMIN_USER_UPDATE_INFO = "ADMIN_USER_UPDATE_INFO";
export const USER_GET_INFORMATION = "USER_GET_INFORMATION";
export const ADMIN_USER_TRANSATION_REPORT = "ADMIN_USER_TRANSATION_REPORT";
export const ADMIN_USER_DOWNLOAD_TRANSATION_REPORT = "ADMIN_USER_DOWNLOAD_TRANSATION_REPORT";
export const ADMIN_USER_UPDATE_PERMISSIONS = "ADMIN_USER_UPDATE_PERMISSIONS";
export const ADMIN_USER_SAVE_WEBSITE_THEME = "ADMIN_USER_SAVE_WEBSITE_THEME";
export const ADMIN_USER_GET_WEBSITE_THEME = "ADMIN_USER_GET_WEBSITE_THEME";
export const ADMIN_USER_RESET_WEBSITE_THEME = "ADMIN_USER_RESET_WEBSITE_THEME";
export const ADMIN_USER_TOGGLE_LANDING_PAGE = "ADMIN_USER_TOGGLE_LANDING_PAGE";
export const ADMIN_USER_REGISTER_WEB_DOMAIN = "ADMIN_USER_REGISTER_WEB_DOMAIN";
export const ADMIN_USER_CONFIG_WEB_SSL = "ADMIN_USER_CONFIG_WEB_SSL";
export const ADMIN_USER_REMOVE_WEB_DOMAIN_CONFIG = "ADMIN_USER_REMOVE_WEB_DOMAIN_CONFIG";
export const ADMIN_USER_SHOW_CONTENT_ON_ORIGINAL_SITE = "ADMIN_USER_SHOW_CONTENT_ON_ORIGINAL_SITE";
export const ADMIN_USER_GENERATE_STREAMING_TICKETS = "ADMIN_USER_GENERATE_STREAMING_TICKETS";
export const ADMIN_USER_GENERATE_EVENT_TICKETS = "ADMIN_USER_GENERATE_EVENT_TICKETS";
export const ADMIN_USER_DOWNLOAD_FREE_TICKETS = "ADMIN_USER_DOWNLOAD_FREE_TICKETS";
export const ADMIN_USER_UPDATE_DEFAULT_INDEX_PAGE = "ADMIN_USER_UPDATE_DEFAULT_INDEX_PAGE";
export const ADMIN_USER_UPDATE_PASSWORD = "ADMIN_USER_UPDATE_PASSWORD";
export const ADMIN_GATEKEEPER_ADD_NEW = "ADMIN_GATEKEEPER_ADD_NEW";
export const ADMIN_GATEKEEPER_UPDATE = "ADMIN_GATEKEEPER_UPDATE";
export const ADMIN_GATEKEEPER_GET_ALL = "ADMIN_GATEKEEPER_GET_ALL";
export const ADMIN_GATEKEEPER_DELETE = "ADMIN_GATEKEEPER_DELETE";
export const ADMIN_TICKET_SELLER_GET_ALL = "ADMIN_TICKET_SELLER_GET_ALL";
export const ADMIN_TICKET_SELLER_DELETE = "ADMIN_TICKET_SELLER_DELETE";
export const ADMIN_TICKET_SELLER_ADD_NEW = "ADMIN_TICKET_SELLER_ADD_NEW";
export const ADMIN_TICKET_SELLER_UPDATE = "ADMIN_TICKET_SELLER_UPDATE";
export const STREAMER_USER_GENERATE_CHANNEL_API_KEY = "STREAMER_USER_GENERATE_CHANNEL_API_KEY";
export const STREAMER_USER_GET_CHANNEL_API_KEY = "STREAMER_USER_GET_CHANNEL_API_KEY";